/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleFilterRequest } from './RoleFilterRequest';
import {
    RoleFilterRequestFromJSON,
    RoleFilterRequestFromJSONTyped,
    RoleFilterRequestToJSON,
    RoleFilterRequestToJSONTyped,
} from './RoleFilterRequest';
import type { ApplicationFilterRequest } from './ApplicationFilterRequest';
import {
    ApplicationFilterRequestFromJSON,
    ApplicationFilterRequestFromJSONTyped,
    ApplicationFilterRequestToJSON,
    ApplicationFilterRequestToJSONTyped,
} from './ApplicationFilterRequest';
import type { ExternalUserStatus } from './ExternalUserStatus';
import {
    ExternalUserStatusFromJSON,
    ExternalUserStatusFromJSONTyped,
    ExternalUserStatusToJSON,
    ExternalUserStatusToJSONTyped,
} from './ExternalUserStatus';
import type { InternalUserSearchOrderByPaginationQuery } from './InternalUserSearchOrderByPaginationQuery';
import {
    InternalUserSearchOrderByPaginationQueryFromJSON,
    InternalUserSearchOrderByPaginationQueryFromJSONTyped,
    InternalUserSearchOrderByPaginationQueryToJSON,
    InternalUserSearchOrderByPaginationQueryToJSONTyped,
} from './InternalUserSearchOrderByPaginationQuery';

/**
 * 
 * @export
 * @interface InternalUserSearchRequest
 */
export interface InternalUserSearchRequest {
    /**
     * 
     * @type {ApplicationFilterRequest}
     * @memberof InternalUserSearchRequest
     */
    applicationFilter?: ApplicationFilterRequest;
    /**
     * 
     * @type {string}
     * @memberof InternalUserSearchRequest
     */
    employeeNr?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalUserSearchRequest
     */
    employmentCategories?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserSearchRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserSearchRequest
     */
    initials?: string | null;
    /**
     * 
     * @type {InternalUserSearchOrderByPaginationQuery}
     * @memberof InternalUserSearchRequest
     */
    paginationQuery?: InternalUserSearchOrderByPaginationQuery;
    /**
     * 
     * @type {RoleFilterRequest}
     * @memberof InternalUserSearchRequest
     */
    roleFilter?: RoleFilterRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalUserSearchRequest
     */
    sections?: Array<string> | null;
    /**
     * 
     * @type {Array<ExternalUserStatus>}
     * @memberof InternalUserSearchRequest
     */
    statusFilter?: Array<ExternalUserStatus> | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserSearchRequest
     */
    surname?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalUserSearchRequest
     */
    workLocations?: Array<string> | null;
}

/**
 * Check if a given object implements the InternalUserSearchRequest interface.
 */
export function instanceOfInternalUserSearchRequest(value: object): value is InternalUserSearchRequest {
    return true;
}

export function InternalUserSearchRequestFromJSON(json: any): InternalUserSearchRequest {
    return InternalUserSearchRequestFromJSONTyped(json, false);
}

export function InternalUserSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalUserSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationFilter': json['applicationFilter'] == null ? undefined : ApplicationFilterRequestFromJSON(json['applicationFilter']),
        'employeeNr': json['employeeNr'] === undefined ? undefined : json['employeeNr'] === null ? null : json['employeeNr'],
        'employmentCategories': json['employmentCategories'] === undefined ? undefined : json['employmentCategories'] === null ? null : json['employmentCategories'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'initials': json['initials'] === undefined ? undefined : json['initials'] === null ? null : json['initials'],
        'paginationQuery': json['paginationQuery'] == null ? undefined : InternalUserSearchOrderByPaginationQueryFromJSON(json['paginationQuery']),
        'roleFilter': json['roleFilter'] == null ? undefined : RoleFilterRequestFromJSON(json['roleFilter']),
        'sections': json['sections'] === undefined ? undefined : json['sections'] === null ? null : json['sections'],
        'statusFilter': json['statusFilter'] === undefined ? undefined : json['statusFilter'] === null ? null : ((json['statusFilter'] as Array<any>).map(ExternalUserStatusFromJSON)),
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'workLocations': json['workLocations'] === undefined ? undefined : json['workLocations'] === null ? null : json['workLocations'],
    };
}

export function InternalUserSearchRequestToJSON(json: any): InternalUserSearchRequest {
    return InternalUserSearchRequestToJSONTyped(json, false);
}

export function InternalUserSearchRequestToJSONTyped(value?: InternalUserSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationFilter': ApplicationFilterRequestToJSON(value['applicationFilter']),
        'employeeNr': value['employeeNr'],
        'employmentCategories': value['employmentCategories'],
        'firstName': value['firstName'],
        'initials': value['initials'],
        'paginationQuery': InternalUserSearchOrderByPaginationQueryToJSON(value['paginationQuery']),
        'roleFilter': RoleFilterRequestToJSON(value['roleFilter']),
        'sections': value['sections'],
        'statusFilter': value['statusFilter'] == null ? undefined : ((value['statusFilter'] as Array<any>).map(ExternalUserStatusToJSON)),
        'surname': value['surname'],
        'workLocations': value['workLocations'],
    };
}

